import { getViewsByParent } from '../BaseTabsRouting/utils';

import { Header } from '../BaseTabsRouting/BaseTabsRouting';
import CLASettings from '../CLA/CLASettings/CLASettings';
import DutyCodes from '../Settings/DutyCodes/DutyCodes';
import AuxiliaryValues from './AuxiliaryValues/AuxiliaryValues';
import MaxCLASettings from './CLA/MaxCLASettings';
import PremiumPay from './CLA/PremiumPay';
import SalaryScales from './CLA/SalaryScales/SalaryScales';
import EmployerCostSettingsGrid from './Employer/EmployerCostSettings/EmployerCostSettingsGrid';
import Employers from './Employer/Employers/Employers';
import SurchargeRelationsGrid from './Employer/SurchargeRelations/SurchargeRelationsGrid';
import SurchargesMaintenance from './Employer/SurchargesMaintenance/SurchargesMaintenance';
import PoolMaintenance from './Pools/PoolMaintenance/PoolMaintenance';
import Functions from './Settings/AdminFunctions/Functions';
import Clusters from './Settings/Clusters/Clusters';
import DHTClaSettings from './Settings/DHTClaSettings/DHTClaSettings';
import DTRRules from './Settings/DTRRules/DTRRules';
import DutyHourTypes from './Settings/DutyHourTypes/DutyHourTypes';
import PlanUnits from './Settings/PlanUnits/PlanUnits';
import Qualifications from './Settings/Qualifications/Qualifications';
import Arrangements from './TravelCosts/Arrangements/Arrangements';
import Distances from './TravelCosts/Distances/Distances';
import AgeHours from './Year/AgeHours/AgeHours';
import HolidayHours from './Year/HolidayHours/HolidayHours';
import Holidays from './Year/Holidays/Holidays';
import HolidaySpecial from './Year/HolidaysSpecial/HolidaySpecial';
import TravelDistances from '../TravelDistances';

export enum AdminTableMenusOptions {
  SETTINGS = 'settings',
  YEAR = 'year',
  TRAVEL_COST = 'travelCost',
  EMPLOYER = 'employer',
  POOLS = 'pools',
  CLA = 'cla'
}

export const adminTableViews = [
  {
    name: 'CLUSTERS',
    Component: Clusters,
    parent: AdminTableMenusOptions.SETTINGS,
    requiredGrants: ['hasClustersOrgGrant']
  },
  {
    name: 'FUNCTIONS',
    Component: Functions,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'DUTY_CODES',
    Component: DutyCodes,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'DUTY_HOUR_TYPES',
    Component: DutyHourTypes,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'QUALIFICATIONS',
    Component: Qualifications,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'SALARY_COMPONENT',
    Component: DHTClaSettings,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'AUXILIARY_VALUES',
    Component: AuxiliaryValues,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'DTR_RULES',
    Component: DTRRules,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'PLAN_UNITS',
    Component: PlanUnits,
    parent: AdminTableMenusOptions.SETTINGS
  },
  {
    name: 'HOLIDAY',
    Component: Holidays,
    parent: AdminTableMenusOptions.YEAR
  },
  {
    name: 'HOLIDAY_SPECIAL',
    Component: HolidaySpecial,
    parent: AdminTableMenusOptions.YEAR
  },
  {
    name: 'HOLIDAY_HOURS',
    Component: HolidayHours,
    parent: AdminTableMenusOptions.YEAR
  },
  {
    name: 'AGE_HOURS',
    Component: AgeHours,
    parent: AdminTableMenusOptions.YEAR
  },
  {
    name: 'ARRANGEMENTS',
    Component: Arrangements,
    parent: AdminTableMenusOptions.TRAVEL_COST
  },
  {
    name: 'DISTANCES',
    Component: Distances,
    parent: AdminTableMenusOptions.TRAVEL_COST
  },
  {
    name: 'TRAVEL_DISTANCES',
    Component: TravelDistances,
    parent: AdminTableMenusOptions.TRAVEL_COST
  },
  {
    name: 'EMPLOYERS',
    Component: Employers,
    parent: AdminTableMenusOptions.EMPLOYER
  },
  {
    name: 'EMPLOYERS_COST_SETTINGS',
    Component: EmployerCostSettingsGrid,
    parent: AdminTableMenusOptions.EMPLOYER
  },
  {
    name: 'SURCHARGES_MAINTENANCE',
    Component: SurchargesMaintenance,
    parent: AdminTableMenusOptions.EMPLOYER
  },
  {
    name: 'SURCHARGES_RELATIONS',
    Component: SurchargeRelationsGrid,
    parent: AdminTableMenusOptions.EMPLOYER
  },
  {
    name: 'POOL_MAINTENANCE',
    Component: PoolMaintenance,
    parent: AdminTableMenusOptions.POOLS
  },
  {
    name: 'CLA',
    Component: CLASettings,
    parent: AdminTableMenusOptions.CLA
  },
  {
    name: 'MAX_CLA_SETTINGS',
    Component: MaxCLASettings,
    parent: AdminTableMenusOptions.CLA
  },
  {
    name: 'SALARY_SCALES',
    Component: SalaryScales,
    parent: AdminTableMenusOptions.CLA
  },
  {
    name: 'ORT',
    Component: PremiumPay,
    parent: AdminTableMenusOptions.CLA
  }
];

// Fixed data for BaseTabsRouting header
export const adminTableHeaders: Header[] = [
  {
    subHeaderName: AdminTableMenusOptions.SETTINGS,
    tabs: getViewsByParent<AdminTableMenusOptions>(
      adminTableViews,
      AdminTableMenusOptions.SETTINGS
    )
  },
  {
    subHeaderName: AdminTableMenusOptions.YEAR,
    tabs: getViewsByParent<AdminTableMenusOptions>(
      adminTableViews,
      AdminTableMenusOptions.YEAR
    )
  },
  {
    subHeaderName: AdminTableMenusOptions.TRAVEL_COST,
    tabs: getViewsByParent<AdminTableMenusOptions>(
      adminTableViews,
      AdminTableMenusOptions.TRAVEL_COST
    ),
    requiredGrants: ['hasTravelCostCalculationAccess']
  },
  {
    subHeaderName: AdminTableMenusOptions.EMPLOYER,
    tabs: getViewsByParent<AdminTableMenusOptions>(
      adminTableViews,
      AdminTableMenusOptions.EMPLOYER
    )
  },
  {
    subHeaderName: AdminTableMenusOptions.POOLS,
    tabs: getViewsByParent<AdminTableMenusOptions>(
      adminTableViews,
      AdminTableMenusOptions.POOLS
    ),
    requiredGrants: ['hasPoolsOrgGrant']
  },
  {
    subHeaderName: AdminTableMenusOptions.CLA,
    tabs: getViewsByParent<AdminTableMenusOptions>(
      adminTableViews,
      AdminTableMenusOptions.CLA
    )
  }
];
